// import SL from '@/layouts/sl'
// import Bus from '_u/bus'

export default [
  // {
  //   name: 'sl',
  //   path: '/sl',
  //   redirect: '/sl/download',
  //   component: SL,
  //   children: [
  //     {
  //       name: 'slDownload',
  //       path: '/sl/download',
  //       component: () => import('_sl/download'),
  //       meta: {
  //         title: 'app下载'
  //       }
  //     },
  //     {
  //       name: 'slDetail',
  //       path: '/sl/detail',
  //       component: () => import('_sl/detail'),
  //       meta: {
  //         title: '详情',
  //         app: true
  //       }
  //     },
  //     {
  //       name: 'slVoteDetail',
  //       path: '/sl/voteDetail',
  //       component: () => import('_sl/voteDetail'),
  //       meta: {
  //         title: '详情',
  //         app: true
  //       }
  //     },
  //     {
  //       name: 'slQuestionDetail',
  //       path: '/sl/questionDetail',
  //       component: () => import('_sl/voteDetail/questionDetail'),
  //       meta: {
  //         title: '详情',
  //         app: true
  //       }
  //     },
  //     {
  //       name: 'slPay',
  //       path: '/sl/pay',
  //       component: () => import('_sl/pay'),
  //       meta: {
  //         title: '账单支付',
  //         app: true
  //       }
  //     },
  //     {
  //       name: 'slPayResults',
  //       path: '/sl/payResults',
  //       component: () => import('_sl/pay/PayResults'),
  //       beforeEnter: (to, from, next) => {
  //         if (!Bus.isApp) location.href = 'LeelenALApp://'
  //         next()
  //       },
  //       meta: {
  //         title: '支付结果',
  //         app: true
  //       }
  //     },
  //     {
  //       name: 'slMessage',
  //       path: '/sl/message',
  //       component: () => import('_sl/message'),
  //       meta: {
  //         title: '消息详情',
  //         app: true
  //       }
  //     }
  //   ]
  // }
]
